module.exports = __webpack_public_path__ + "static/hero-uni926466-b3657978ba892b5c8061b4f9fcf553d3.png";